import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import Logo from './Logo';
import { Stack } from 'rsuite';
// import img from './erp.png';
import * as images from '../images/charts';
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import MenuIcon from '@rsuite/icons/Menu';
import { Icon } from '@rsuite/icons';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';
import ip from '../GlobelIP';

const Brand = props => {
  const [companydata, setCompanyData] = useState({});
  useEffect(() => {
    fetchcompData();
  }, []);
  const fetchcompData = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      if (json.data && json.data[0]) {
        setCompanyData(json.data[0]);
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };
  return (
    <Stack className="brand" style={{ width: '230px', justifyContent: 'space-evenly' }} {...props}>
      {/* <Logo height={26} style={{ marginTop: 6 }} /> */}

      <Link to={`/${ugr}/dashboard`} style={{ display: 'inline-block', maxWidth: '220px', width: '100%' }}>
        {companydata?.attributes?.Logo?.data?.attributes?.url ? (
          <img
            src={`${ip}${companydata?.attributes?.Logo?.data?.attributes?.url}`}
            alt="Company Logo"
            style={{
              width: '80%',         // scales automatically to container width
              height: 'auto',        // keeps original aspect ratio
              objectFit: 'contain',  // ensures full image visibility
              maxHeight: '60px'      // prevents oversized logos
            }}
          />
        ) : (
          <p style={{ fontSize: '14px', color: '#999', margin: 0 }}>Company logo</p>
        )}
      </Link>

      <div className="" style={{ width: '65px' }}>
        <Icon as={MenuIcon} />
      </div>
    </Stack>
  );
};

export default Brand;
